// extracted by mini-css-extract-plugin
export default {"cls1":"SelectRegion-WarningIcon_cls1__5RHtu","cls2":"SelectRegion-WarningIcon_cls2__JezBw SelectRegion-WarningIcon_cls1__5RHtu"};